export const ADVERTISER = '/adv'
export const ADVERTISER_CREATE = '/adv/create'
export const ADVERTISER_COPY = '/adv/:id/copy'
export const ADVERTISER_EDIT = '/adv/:id/edit'

export const LOGS = '/logs'